import { useIdentity } from '@interhyp/platform-auth';
import { SET_CUSTOMER_ID, SET_INTENT_ID, useTracking } from '@interhyp/util-tracking';
import { useEffect } from 'react';

import { useRouterIntentId } from './useRouterIntentId';

export function useCoreTracking(): void {
  const { trackEvent } = useTracking();
  const identity = useIdentity();
  const customerId = identity?.userId;
  const intentId = useRouterIntentId();

  // Track customer
  useEffect(() => {
    if (customerId) {
      trackEvent({
        type: SET_CUSTOMER_ID,
        customerId,
      });
    }
  }, [trackEvent, customerId]);

  // Track intent
  useEffect(() => {
    if (intentId) {
      trackEvent({
        type: SET_INTENT_ID,
        intentId,
      });
    }
  }, [trackEvent, intentId]);
}
